<template>
<e-chart ref="chart" />
</template>

<script>
import {AXIS_LABEL, AXIS_LINE_STYLE, NUMBER_FONT_FAMILY} from './FactorCharts/chartStyle'
export default {
  name: 'AQISequentialChart',
  props: {
    data: {
      required: true,
      type: Object
    },
    currentRadio: {
      required: true,
      type: String
    },
    currentRadioName: {
      required: true,
      type: String
    },
    granularity: {
      required: true,
      type: String
    },
    noDataReasonMap: {
      type: Object
    }
  },
  watch: {
    data (val) {
      if (val) {
        this.render()
      }
    }
  },
  methods: {
    render (isReal) {
      let {data: {dataTime, series}, granularity, currentRadio, currentRadioName, noDataReasonMap} = this
      let xAxisData = dataTime.map(el => {
        if (granularity === 'hour') {
          return new Date(el).format('YYYY/MM/DD HH')
        } else if (granularity === 'day') {
          return new Date(el).format('YYYY/MM/DD')
        } else {
          return new Date(el).format('YYYY/MM')
        }
      })
      let seriesData
      if (currentRadioName === '综合') {
        seriesData = series.map(el => {
          return {
            ...el,
            yAxisIndex: el.name === 'AQI' || el.name === '综合指数' ? 0 : (el.name === 'CO' ? 2 : 1)
          }
        })
      } else {
        seriesData = series.filter(el => el.name === currentRadioName)
      }
      console.log(series)
      let yAxisData
      if (currentRadio === 'all') {
        yAxisData = [{
          name: '监测值',
          type: 'value',
          nameGap: 10,
          axisLine: {
            show: true,
            lineStyle: AXIS_LINE_STYLE
          },
          splitLine: {
            show: true
          },
          axisLabel: {
            ...AXIS_LABEL,
            fontFamily: NUMBER_FONT_FAMILY
          }
        }, {
          name: 'μg/m3',
          type: 'value',
          nameGap: 10,
          position: 'right',
          offset: 50,
          axisLine: {
            show: true,
            lineStyle: AXIS_LINE_STYLE
          },
          splitLine: {
            show: true
          },
          axisLabel: {
            ...AXIS_LABEL,
            fontFamily: NUMBER_FONT_FAMILY
          }
        }, {
          name: 'mg/m3',
          type: 'value',
          nameGap: 10,
          position: 'right',
          axisLine: {
            show: true,
            lineStyle: AXIS_LINE_STYLE
          },
          splitLine: {
            show: true
          },
          axisLabel: {
            ...AXIS_LABEL,
            fontFamily: NUMBER_FONT_FAMILY
          }
        }]
      } else if (currentRadio === 'aqi' || currentRadio === 'count') {
        yAxisData = [{
          name: '监测值',
          type: 'value',
          nameGap: 10,
          axisLine: {
            show: true,
            lineStyle: AXIS_LINE_STYLE
          },
          splitLine: {
            show: true
          },
          axisLabel: {
            ...AXIS_LABEL,
            fontFamily: NUMBER_FONT_FAMILY
          }
        }]
      } else {
        yAxisData = [{
          name: currentRadio === '1005' ? 'mg/m3' : 'μg/m3',
          type: 'value',
          nameGap: 10,
          axisLine: {
            show: true,
            lineStyle: AXIS_LINE_STYLE
          },
          splitLine: {
            show: true
          },
          axisLabel: {
            ...AXIS_LABEL,
            fontFamily: NUMBER_FONT_FAMILY
          }
        }]
      }

      let chartOpt = {
        legend: {
          itemGap: 20,
          textStyle: {
            fontSize: 14
          }
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          right: 10
        },
        tooltip: {
          trigger: 'axis',
          appendToBody: true,
          formatter: params => {
            const param = params[0]
            return `<div>${param.name}</div><div style="display:grid;grid-template-columns:repeat(3,max-content);grid-column-gap:5px;align-items:center;">${params.map(param => {
              let value = parseFloat(param.value)

              if (!Number.isFinite(value) && noDataReasonMap) {
                const {data} = param
                const key = `${data.siteId}-${data.id}-${data.dataTime}`
                const noDataReason = noDataReasonMap[key]
                value = noDataReason ? noDataReason.reason : '--'
              }

              return `${param.marker}<span>${param.seriesName}:</span><span style="text-align:right;">${value}</span>`
            }).join('')}</div>`
          }
        },
        grid: [{
          top: 50,
          right: 50,
          bottom: 50,
          left: 50,
          containLabel: true
        }],
        xAxis: {
          type: 'category',
          data: xAxisData
        },
        yAxis: yAxisData,
        dataZoom: [{
          type: 'inside',
          start: 0,
          end: 100,
          realtime: true,
          xAxisIndex: 0,
          minSpan: 5
        }, {
          type: 'slider',
          start: 0,
          end: 100,
          realtime: true,
          xAxisIndex: 0,
          minSpan: 5,
          // height: 39,
          bottom: 9,
          left: 'center',
          handleIcon: 'M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
          handleSize: '70%',
          handleStyle: {
            color: '#fff',
            shadowBlur: 4,
            shadowColor: 'rgba(0, 0, 0, 0.15)',
            shadowOffsetX: 2,
            shadowOffsetY: 2
          },
          // dataBackground: {
          //   areaStyle: '#E4F0FF'
          // }
          fillerColor: 'rgba(228, 240, 255, .6)',
          borderColor: '#E4F0FF'
        }],
        series: seriesData
      }

      this.$refs.chart.setOpt(chartOpt)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Data/TimingAnalysisChart.vue